<script lang="ts">
    interface Props {
        brand: string;
    }

    let { brand }: Props = $props();
</script>

<span class="reptile-product-brand">{brand}</span>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-product-brand {
        text-transform: uppercase;
        font-family: tokens.$oc-semantic-font-copy-font-family;
        font-size: tokens.$oc-base-font-size-75;
        font-weight: tokens.$oc-base-font-weight-regular;
        line-height: tokens.$oc-base-font-line-height-100;
    }
</style>
